import { addErrorToast } from './companyActionCreators'
import {
  RECON_LOADING,
  RECON_LOADED,
  RECON_COMPANYLIST_LOADED,
  RECON_COMPANY_SELECTED,
  RECON_SELECTED,
  RECON_DETAILS_LOADED,
  RECON_UPLOADING_LOADED,
  RECON_UPLOADING_LOADING,
  RECON_UPLOAD_UPDATE,
  RECON_UPLOADING_FAILED,
  RECON_UPLOAD_CLEARED,
  INVOICE_LOADING,
  INVOICE_DETAILS_LOADED,
  INVOICE_DETAILS_LOADING_ERROR,
  RECON_RE_UPLOADING_LOADED,
  RECON_UPLOAD_INVOICE_UPDATE,
  RECON_RE_UPLOADING_FAILED,
  ESS_RECON_COMPANYLIST_LOADED,
} from './reconciliationActions'

import api from '../../services/api'
import { push } from 'connected-react-router'

export const handleReconLoading = () => {
  return {
    type: RECON_LOADING,
  }
}

export const handleReconLoaded = () => {
  return {
    type: RECON_LOADED,
  }
}

export const reconListLoaded = (payload) => {
  return {
    type: RECON_COMPANYLIST_LOADED,
    payload: payload,
  }
}

export const essentialsReconListLoaded = (payload) => {
  return {
    type: ESS_RECON_COMPANYLIST_LOADED,
    payload: payload,
  }
}

export const handleUpdateSelectedCompany = (payload) => {
  return {
    type: RECON_COMPANY_SELECTED,
    payload: payload,
  }
}

export const handleUpdateSelectedRecon = (payload) => {
  return {
    type: RECON_SELECTED,
    payload: payload,
  }
}

export const reconDetailsLoaded = (payload) => {
  return {
    type: RECON_DETAILS_LOADED,
    payload: payload,
  }
}

export const handleUploadingLoaded = (index) => {
  return {
    type: RECON_UPLOADING_LOADED,
    payload: index,
  }
}

export const handleReUploadingLoaded = (index) => {
  return {
    type: RECON_RE_UPLOADING_LOADED,
    payload: index,
  }
}

export const handleUploadingLoadedError = (productId, index) => {
  return {
    type: RECON_UPLOADING_FAILED,
    payload: {
      productId,
      index,
    },
  }
}

export const handleReUploadingLoadedError = (cW_Product_RecID, index) => {
  return {
    type: RECON_RE_UPLOADING_FAILED,
    payload: {
      cW_Product_RecID,
      index,
    },
  }
}

export const handleUploadingLoading = (index) => {
  return {
    type: RECON_UPLOADING_LOADING,
    payload: index,
  }
}

export const handleUpdateUploadData = (productId, data) => {
  return {
    type: RECON_UPLOAD_UPDATE,
    payload: {
      productId,
      data,
    },
  }
}

export const handleReUpdateUploadData = (cW_Product_RecID, data) => {
  return {
    type: RECON_UPLOAD_INVOICE_UPDATE,
    payload: {
      cW_Product_RecID,
      data,
    },
  }
}

export const handleUploadCleared = (productId) => {
  return {
    type: RECON_UPLOAD_CLEARED,
    payload: {
      productId,
    },
  }
}

export const fetchReconDetails = (id) => async (dispatch) => {
  dispatch(handleReconLoading())
  try {
    const res = await api.get(`/reconciliation/${id}`)
    const data = await res.json()

    dispatch(reconDetailsLoaded(data))
    dispatch(handleReconLoaded())
  } catch (e) {
    dispatch(addErrorToast(e))
    dispatch(handleReconLoaded())
  }
}

export const fetchReconCompanyList = (fetchType) => async (dispatch) => {
  try {
    if (fetchType === 'essentials') {
      const res = await api.get(`/reconciliation/essentialsCompanies`)
      const data = await res.json()

      dispatch(essentialsReconListLoaded(data))
    } else {
      const res = await api.get(`/reconciliation/companies`)
      const data = await res.json()

      dispatch(reconListLoaded(data))
    }

    dispatch(handleReconLoaded())
  } catch (e) {
    dispatch(addErrorToast(e))
    dispatch(handleReconLoaded())
  }
}

export const handleDetailsClick = (id) => async (dispatch) => {
  dispatch(handleUpdateSelectedCompany(id))
  dispatch(push(`/reconciliation/${id}/List`))
}

export const handleLoadReconProducts = (companyId, reconId) => async (dispatch) => {
  dispatch(handleUpdateSelectedRecon(reconId))
  dispatch(push(`/reconciliation/${companyId}/Details/${reconId}`))
}

export const handleReUploadUserCSV = (
  cW_Item_RecID,
  cW_Product_RecID,
  data,
  index,
  cwCompanyId,
  billingLogRecId
) => async (dispatch) => {
  dispatch(handleUploadingLoading(index))
  try {
    const res = await api.post(`/reconciliation/ReUpload`, {
      billingLogRecId,
      data,
      cwCompanyId,
      cW_Item_RecID,
    })
    const resData = await res.json()

    if (res.ok) {
      dispatch(handleReUpdateUploadData(cW_Product_RecID, resData))
      dispatch(handleUploadingLoaded(index))
    } else {
      dispatch(addErrorToast('Error'))
    }
  } catch (e) {
    dispatch(addErrorToast(e))
    dispatch(handleReUploadingLoadedError(cW_Product_RecID, index))
  }
}

export const handleUploadUserCSV = (reconId, productId, data, index, companyId, isEssentialsSelected) => async (
  dispatch
) => {
  dispatch(handleUploadingLoading(index))
  try {
    const res = await api.post(`/reconciliation/${reconId}/Product/${productId}/upload/${companyId}`, {
      data,
      isEssentialsSelected,
    })
    const resData = await res.json()
    dispatch(handleUpdateUploadData(productId, resData))
    dispatch(handleUploadingLoaded(index))
  } catch (e) {
    dispatch(addErrorToast(e))
    dispatch(handleUploadingLoadedError(productId, index))
  }
}

export const handleClearUpload = (reconId, productId, index) => async (dispatch) => {
  dispatch(handleUploadingLoading(index))
  try {
    const res = await api.deleteCall(`/reconciliation/${reconId}/Product/${productId}/upload`)

    if (res.ok) {
      dispatch(handleUploadCleared(productId))
      dispatch(handleUploadingLoaded(index))
    } else {
      dispatch(addErrorToast('Error'))
      dispatch(handleUploadingLoadedError(productId, index))
    }
  } catch (e) {
    dispatch(addErrorToast(e))
    dispatch(handleUploadingLoadedError(productId, index))
  }
}

export const handleInvoiceLoading = () => {
  return {
    type: INVOICE_LOADING,
  }
}

export const handleLoadedInvoiceDetails = (payload) => {
  return {
    type: INVOICE_DETAILS_LOADED,
    payload: payload,
  }
}

export const handleInvoiceLoadingError = (payload) => {
  return {
    type: INVOICE_DETAILS_LOADING_ERROR,
    payload: payload,
  }
}
export const handleLoadInvoiceDetails = (invoiceId) => async (dispatch) => {
  dispatch(handleInvoiceLoading())
  try {
    const res = await api.get(`/reconciliation/invoice/${invoiceId}`)
    const data = await res.json()

    if (res.ok) {
      dispatch(handleLoadedInvoiceDetails(data))
    } else {
      dispatch(handleInvoiceLoadingError(invoiceId))
    }
  } catch (error) {
    dispatch(handleInvoiceLoadingError(invoiceId))
  }
}
